import { VCList } from 'data/VCList/VCList';
import { APIError } from 'models/baseResponse'

/* eslint-disable  @typescript-eslint/no-explicit-any */
export function reactQueryRetryHandler(failureCount: any, error: any) {
  return !(
    failureCount > 3 ||
    (error instanceof APIError && error.status && [400, 404].indexOf(error.status) !== -1)
  )
}

export function toSlug(name: string) {
  if (!name) return "";

  // First replace "+" with "plus" before other transformations
   name = name.replace(/\+/g, "-plus");
  
  // First replace "+" with "plus" before other transformations
  name = name.replace(/\+/g, "plus");
  
  // Türkçe karakter dönüşüm haritası
  const turkishChars: { [key: string]: string } = {
    'ğ': 'g',
    'ü': 'u',
    'ş': 's',
    'ı': 'i',
    'ö': 'o',
    'ç': 'c',
    'Ğ': 'G',
    'Ü': 'U',
    'Ş': 'S',
    'İ': 'I',
    'Ö': 'O',
    'Ç': 'C'
  };

  return name
    .toString()
    .toLowerCase()
    // Türkçe karakterleri değiştir
    .replace(/[ğüşıöçĞÜŞİÖÇ]/g, letter => turkishChars[letter] || letter)
    // Alfanumerik olmayan karakterleri tire ile değiştir
    .replace(/[^a-z0-9]+/g, "-")
    // Baştaki ve sondaki tireleri kaldır
    .replace(/(^-|-$)/g, "");
}

export function groupByMainInstitution() {
  // Helper function to convert a name to a slug
  const toSlug = (name: string) =>
    name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

  // Create a map to group by `mainInstitution`
  const grouped = VCList.reduce((acc: any, item) => {
    const institutionName = item.mainInstitution.toString();

    // If the group doesn't exist, create it
    if (!acc[institutionName]) {
      acc[institutionName] = {
        name: institutionName,
        slug: toSlug(institutionName),
        children: [],
      };
    }

    // Add the current item to the children of the group
    acc[institutionName].children.push(item);

    return acc;
  }, {} as Record<string, { name: string; slug: string; children: any }>);

  // Convert the map to an array
  return Object.values(grouped);
}
